/**
 * Module icon registry.
 *
 * `auth.modules.icon` stores a lucide-react icon name (see
 * `packages/auth/src/policy.ts`). The database and the policy file are the
 * contract between the API and every client, so the rebuild does not rename
 * those values — this map translates them to Fluent 2 icons at render time.
 *
 * Each entry is a `bundleIcon` pair: the outline is used normally and the solid
 * fill when the icon's owner is selected, which is the Fluent 2 navigation
 * convention.
 *
 * Adding a module: add its lucide name here alongside the closest Fluent icon.
 * An unmapped name renders `Circle`, exactly as the lucide version did.
 */
import { ArrowTrendingLines20Filled, ArrowTrendingLines20Regular, Board20Filled, Board20Regular, Circle20Filled, Circle20Regular, ClipboardCheckmark20Filled, ClipboardCheckmark20Regular, CalendarWorkWeek20Filled, CalendarWorkWeek20Regular, Clock20Filled, Clock20Regular, DataTrending20Filled, DataTrending20Regular, Handshake20Filled, Handshake20Regular, HatGraduation20Filled, HatGraduation20Regular, Laptop20Filled, Laptop20Regular, Money20Filled, Money20Regular, News20Filled, News20Regular, Organization20Filled, Organization20Regular, People20Filled, People20Regular, Shield20Filled, Shield20Regular, Table20Filled, Table20Regular, Target20Filled, Target20Regular, bundleIcon, } from '@fluentui/react-icons';
export const FallbackModuleIcon = bundleIcon(Circle20Filled, Circle20Regular);
const MODULE_ICONS = {
    // lucide name              → Fluent 2 equivalent
    LayoutDashboard: bundleIcon(Board20Filled, Board20Regular),
    Network: bundleIcon(Organization20Filled, Organization20Regular),
    Newspaper: bundleIcon(News20Filled, News20Regular),
    Clock: bundleIcon(Clock20Filled, Clock20Regular),
    ChartLine: bundleIcon(DataTrending20Filled, DataTrending20Regular),
    Laptop: bundleIcon(Laptop20Filled, Laptop20Regular),
    ClipboardCheck: bundleIcon(ClipboardCheckmark20Filled, ClipboardCheckmark20Regular),
    TrendingUp: bundleIcon(ArrowTrendingLines20Filled, ArrowTrendingLines20Regular),
    DollarSign: bundleIcon(Money20Filled, Money20Regular),
    Target: bundleIcon(Target20Filled, Target20Regular),
    Shield: bundleIcon(Shield20Filled, Shield20Regular),
    Users: bundleIcon(People20Filled, People20Regular),
    Handshake: bundleIcon(Handshake20Filled, Handshake20Regular),
    KanbanSquare: bundleIcon(Table20Filled, Table20Regular),
    GraduationCap: bundleIcon(HatGraduation20Filled, HatGraduation20Regular),
    CalendarRange: bundleIcon(CalendarWorkWeek20Filled, CalendarWorkWeek20Regular),
};
/** Resolves a stored icon name to a component. Never throws; never returns undefined. */
export function moduleIcon(name) {
    if (!name)
        return FallbackModuleIcon;
    return MODULE_ICONS[name] ?? FallbackModuleIcon;
}
//# sourceMappingURL=icons.js.map